import exponent from "./exponent";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-format/src/precisionFixed.js
// module id = 376
// module chunks = 0